module.exports = __webpack_public_path__ + "2acb60f2/img/boston-lights.a623432f.png";